import * as React from 'react';
import {cn} from '../lib/utils';
import {DocumentIcon} from '../document-icon';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../primitives';
import type {ChatAttachment} from '../hooks/chat/types';

export interface MessageAttachmentsProps {
  attachments: ChatAttachment[];
  className?: string;
}

export const MessageAttachments = React.forwardRef<
  HTMLDivElement,
  MessageAttachmentsProps
>(({attachments, className}, ref) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={300}>
      <div ref={ref} className={cn('flex flex-wrap gap-1.5', className)}>
        {attachments.map((attachment) => (
          <Tooltip key={attachment.id}>
            <TooltipTrigger asChild>
              <div className="flex items-center gap-1.5 rounded-md border border-border bg-accent/50 px-2 py-1 text-xs text-muted-foreground">
                <DocumentIcon
                  contentType={attachment.contentType}
                  name={attachment.name}
                  className="shrink-0"
                />
                <span className="max-w-[150px] truncate">
                  {attachment.name}
                </span>
              </div>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs break-all">
              {attachment.name}
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
});
MessageAttachments.displayName = 'MessageAttachments';
